
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityMatchRuleDialog extends SiteEntityDialog<SecurityMatchRuleRow, any> {
        protected getFormKey() { return SecurityMatchRuleForm.formKey; }
        protected getIdProperty() { return SecurityMatchRuleRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMatchRuleRow.localTextPrefix; }
        protected getNameProperty() { return SecurityMatchRuleRow.nameProperty; }
        protected getService() { return SecurityMatchRuleService.baseUrl; }
        protected getDeletePermission() { return SecurityMatchRuleRow.deletePermission; }
        protected getInsertPermission() { return SecurityMatchRuleRow.insertPermission; }
        protected getUpdatePermission() { return SecurityMatchRuleRow.updatePermission; }

        protected form = new SecurityMatchRuleForm(this.idPrefix);
        constructor() {
            super();
            $('a[href="/Data/SecurityMatchRule"]').closest('li').addClass('active');
            $('a[href="/Data/SecurityMatchRuleset"]').closest('li').removeClass('active');
        } 

    }
}